import {FC} from 'react'

import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const BellIcon: FC<IconProps> = ({color = theme.palette.text.default, size}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0.991394C8.55165 0.991394 7.36398 2.10759 7.2503 3.52671L7.17688 3.56342C5.37782 4.46295 4.2414 6.30172 4.2414 8.31314V10.1881C4.2414 11.0508 3.97831 11.893 3.48725 12.6024L2.12628 14.5682C1.96567 14.8002 1.94709 15.1022 2.07805 15.3521C2.209 15.602 2.46785 15.7586 2.75002 15.7586H6.74141C6.74606 17.5544 8.2032 19.0086 10 19.0086C11.7968 19.0086 13.254 17.5544 13.2586 15.7586H17.25C17.5322 15.7586 17.791 15.602 17.922 15.3521C18.0529 15.1022 18.0344 14.8002 17.8737 14.5682L16.5128 12.6024C16.0217 11.893 15.7586 11.0508 15.7586 10.1881V8.31314C15.7586 6.30172 14.6222 4.46295 12.8232 3.56342L12.7497 3.52671C12.6361 2.10759 11.4484 0.991394 10 0.991394ZM11.7414 15.7586H8.25866C8.2633 16.7164 9.04115 17.4914 10 17.4914C10.9589 17.4914 11.7367 16.7164 11.7414 15.7586ZM8.75864 3.75001C8.75864 3.06442 9.31442 2.50864 10 2.50864C10.6856 2.50864 11.2414 3.06442 11.2414 3.75001V4.00001C11.2414 4.28736 11.4037 4.55004 11.6608 4.67855L12.1446 4.92048C13.4297 5.563 14.2414 6.87641 14.2414 8.31314V10.1881C14.2414 11.3595 14.5986 12.5029 15.2653 13.466L15.8021 14.2414H4.1979L4.73471 13.466C5.40144 12.5029 5.75864 11.3595 5.75864 10.1881V8.31314C5.75864 6.87641 6.57037 5.563 7.85541 4.92048L8.33928 4.67855C8.59629 4.55004 8.75864 4.28736 8.75864 4.00001V3.75001Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
